import PropTypes from 'prop-types'

import './footer.scss'

const Footer = ({ baseUrl }) => {
  const links = [
    {
      text: 'Cookie & Privacy Policy',
      url: `${baseUrl}/cookie-privacy-policy`,
    },
    {
      text: 'Website Security',
      url: `${baseUrl}/website-security`,
    },
    {
      text: 'Copyright & Conditions of Use',
      url: `${baseUrl}/copyright-conditions-of-use`,
    },
    {
      text: 'Policies & Conditions',
      url: `${baseUrl}/policies-and-conditions`,
    },
    {
      text: 'Modern Slavery Statement',
      url: `${baseUrl}/policies-and-conditions/modern-slavery-and-human-trafficking`,
    },
    {
      text: 'Website Feedback',
      url: `${baseUrl}/policies-and-conditions/website-feedback`,
    },
    {
      text: 'Job Application Privacy',
      url: `${baseUrl}/sites/default/files/documents/Privacy Notice for Job Applicants.pdf`,
    },
    {
      text: 'Employee Gateway',
      url: `${baseUrl}/employee-gateway`,
    },
  ]
  return (
    <footer className="footer print:hidden">
      <div className="links">
        {links.map(link => (
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="link"
            key={link.text}
            href={link.url}
          >
            {link.text}
          </a>
        ))}
      </div>
      <p className="copyright">
        © Copyright {new Date().getFullYear()} Red Funnel Ferries. All rights
        reserved.
      </p>
    </footer>
  )
}

Footer.propTypes = {
  baseUrl: PropTypes.string.isRequired,
}

export default Footer
